class SearchController {
  constructor() {
    let ajaxType = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 7383;
    this.ajaxType = ajaxType;
    this.scrollToTopOfElement = ($element, deltaTop) => {
      window.scrollTo({
        top: $element.offsetTop - deltaTop,
        behavior: 'smooth'
      });
    };
  }
  init() {
    document.querySelectorAll('.js-solr-ajaxified').forEach($link => {
      const href = $link.getAttribute('href');
      if (window.location.href.indexOf(href) >= 0) {
        $link.classList.add('active');
      }
    });
    const $allLink = document.querySelector('.js-solr-ajaxified[href*="all"]');
    if (!document.querySelectorAll('.js-solr-ajaxified.active').length && $allLink) {
      $allLink.classList.add('active');
    }
    document.addEventListener('click', e => {
      const $target = e.target;
      const $solrAjaxified = $target.classList.contains('js-solr-ajaxified') ? $target : $target.closest('.js-solr-ajaxified');
      if ($solrAjaxified) {
        e.preventDefault();
        this.handleClickOnAjaxifiedUri($solrAjaxified);
      }
    });
  }
  handleClickOnAjaxifiedUri($link) {
    const $solrContainer = $link.closest('.tx_solr');
    $solrContainer.querySelectorAll('.js-solr-ajaxified.active').forEach($active => $active.classList.remove('active'));
    $link.classList.add('active');
    const href = $link.getAttribute('href');
    const $mainSearchTabs = document.querySelector('.main-search-tabs');
    const $mainSearchResult = document.querySelector('.main-search-result');
    if ($mainSearchResult && $mainSearchTabs) {
      $mainSearchTabs.classList.add('loading');
      $mainSearchResult.classList.add('loading');
    }
    fetch(`${href}&type=${this.ajaxType}`).then(res => res.text()).then(data => {
      const $template = document.createElement('template');
      $template.insertAdjacentHTML('afterbegin', data);
      const $tempSearchResult = $template.querySelector('.main-search-result');
      if ($tempSearchResult) {
        $solrContainer.querySelector('.main-search-result').innerHTML = $tempSearchResult.innerHTML;
      }
      this.scrollToTopOfElement($solrContainer, 50);
      window.history.replaceState({}, null, href);
      if ($mainSearchResult && $mainSearchTabs) {
        $mainSearchTabs.classList.remove('loading');
        $mainSearchResult.classList.remove('loading');
      }
    });
  }
  setAjaxType(ajaxType) {
    this.ajaxType = ajaxType;
  }
}
export default SearchController;